import axios from 'axios'
import { Toast } from 'vant'

// const urlMap = {
//   production: 'https://api-gateway.hzmantu.com',
//   opsproduction: 'https://api.pre.hzmantu.com',
//   development: 'https://api.dev.hzmantu.com',
//   // development: 'https://crm-2-0-20.deploy.release.hzmantu.com',
//   msgCode: 'https://mantu-tech-micro-api-proxy.api.hzmantu.com'
// }

const errMap = {
  43000008713: '验证码错误',
  43000008736: '验证码已过期',
  0xA03001021: '您暂无权限领取，去看看其他活动吧～',
  0xA22030001: '优惠券限领人数不足'
}

const handle_arr = [43000008712, 43000008727, 54056202242, 43000008738]

const request = axios.create({
  // baseURL: urlMap[process.env.NODE_ENV],
  baseURL: process.env.VUE_APP_API_HOST,
  headers: {
    'Content-Type': 'application/json'
  },
  timeout: 10000
})

request.interceptors.request.use(config => {
  config.headers['x-stream-id'] = localStorage.getItem('x_stream_id')

  // bms 接口特殊处理
  if (config.baseCode) {
    // config.baseURL = urlMap.msgCode
    config.baseURL = 'https://mantu-tech-micro-api-proxy.api.hzmantu.com'
  }

  return config
}, err => {
  return Promise.reject(err)
})

request.interceptors.response.use(res => {
  if (res.headers['x-stream-id'] && res.data.msg === 'login success') {
    localStorage.setItem('x_stream_id', res.headers['x-stream-id'])
  }
  return Promise.resolve(res.data)
}, err => {
  const data = err.response.data
  if (handle_arr.some(code => code === data.error_code)) {
    return Promise.resolve(data)
  } else if (data.error_msg === 'current can not get user authority, try it later') {
    Toast('登录过期了')
    return Promise.reject(data)
  } else {
    Toast(errMap[data.error_code] || '系统异常')
    return Promise.reject(data)
  }
})

export default request
